import script from "./ADL.vue?vue&type=script&lang=js"
export * from "./ADL.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__